import styled from "styled-components";

export const CardsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Line = styled.hr`
  color: #edecec;
  margin: 16px 0;
`;
